import clsx from 'clsx';
import React from 'react';

import styles from './Checkbox.module.scss';

export type CheckBoxProps = React.InputHTMLAttributes<HTMLInputElement> & { dark?: boolean };

enum CHECKBOX_KEY {
  CHECKED = 'CHECKED',
  UNCHECKED = 'UNCHECKED',
}

const Checkbox: React.FC<CheckBoxProps> = ({ dark, ...otherProps }) => (
  <span className={styles.container}>
    <input
      type="checkbox"
      {...otherProps}
      className={clsx(styles.checkbox, dark && styles.dark)}
      // force rerender when checked status is changed
      key={otherProps.checked ? CHECKBOX_KEY.CHECKED : CHECKBOX_KEY.UNCHECKED}
    />
  </span>
);

export default Checkbox;
